import React, { useState } from 'react';
import { func, string, object } from 'prop-types';
import SearchCriteria from '../../ui-components/core-pricing-component/search-cirteria/search-criteria.jsx';
import LayoutTwoVerticalGrids from '../../ui-components/layouts/layout-two-vertical-grids.jsx';
import { SCREEN_NAMES } from '../../utils/constants.js';
import { NOTIFICATION_MESSAGES } from '../../utils/notification-messages.js';
import { toastWarn } from '../../utils/toasts.js';
import {
   createApiPayload,
   validateReceivedDateFormat,
} from './__helpers__/functions.js';
import {
   RECORD_2_TABLE_HEADERS,
   RULES_RECORD_2_TABLE_HEADERS,
} from './__helpers__/tableHeaders.js';
import footNotesSearchCriteria from './__mocks__/footnotesSearchCriteria.js';
import rulesSearchCriteria from './__mocks__/rulesSearchCriteria.js';
import FootnotesAndRulesTable from './footnotes-and-rules-tables.jsx';

const CorePricingFootnotesAndRules = ({
   updateParentSearchCriteria,
   currentScreen,
   selectedSearchCriteria,
}) => {
   const [searchQuery, setSearchQuery] = useState({});
   const [abortSearch, setAbortSearch] = useState(false);
   const [isExpanded, setIsExpanded] = useState(true);

   const handleSearch = (searchQuery) => {
      const queryData = searchQuery.filter((category) =>
         category.screen.includes(currentScreen)
      );

      const apiPayload = createApiPayload({
         queryData,
         queryScreen: currentScreen,
      });
      const isEmptyPayload = Object.keys(apiPayload).length <= 4;

      if (isEmptyPayload) {
         toastWarn(NOTIFICATION_MESSAGES.EMPTY_SEARCH_CRITERIA);
         return;
      }

      if (!validateReceivedDateFormat(apiPayload)) {
         toastWarn(
            `Received ${NOTIFICATION_MESSAGES.INVALID_DATE_TIME_FORMAT}`
         );
         return;
      }

      setSearchQuery(apiPayload);
      setIsExpanded(false);
      setAbortSearch(false);
   };

   const handleSearchCriteriaSubmit = (payload) => {
      const isEmptyPayload =
         !payload ||
         (!Array.isArray(payload) && Object.keys(payload).length === 0);
      if (isEmptyPayload) {
         toastWarn(NOTIFICATION_MESSAGES.EMPTY_SEARCH_CRITERIA);
         return;
      }
   };

   const handleValidationError = (error) => toastWarn(error);
   const handleStopSearchRequest = () => setAbortSearch(true);
   const toggleSearchCriteria = (isSearchCriteriaExpanded) => {
      setIsExpanded(isSearchCriteriaExpanded);
   };

   const searchCriteriaData =
      currentScreen === SCREEN_NAMES.RULES
         ? rulesSearchCriteria
         : footNotesSearchCriteria;

   return (
      <LayoutTwoVerticalGrids
         leftComponent={
            <SearchCriteria
               currentScreen={currentScreen}
               showWarning={handleValidationError}
               getSearchCriteria={updateParentSearchCriteria}
               isTariffNumberAvailable={false}
               handleSearchCriteriaSearch={handleSearch}
               handleStopSearchRequest={handleStopSearchRequest}
               data={selectedSearchCriteria}
            />
         }
         rightComponent={
            <FootnotesAndRulesTable
               currentScreen={currentScreen}
               searchQuery={searchQuery}
               abortSearch={abortSearch}
               tableHeaders={
                  currentScreen === 'Footnotes'
                     ? RECORD_2_TABLE_HEADERS
                     : RULES_RECORD_2_TABLE_HEADERS
               }
               noResultMessage={`No ${
                  currentScreen === 'Footnotes' ? 'Footnote ' : 'Rule '
               }results found`}
            />
         }
         isExpanded={isExpanded}
         isCorePricing
         handleStatusLeftSideLayout={toggleSearchCriteria}
      />
   );
};

CorePricingFootnotesAndRules.propTypes = {
   updateParentSearchCriteria: func,
   currentScreen: string,
   selectedSearchCriteria: object,
};

export default CorePricingFootnotesAndRules;
